import PropTypes from 'prop-types';
import { Collapse } from 'antd';
import { CardTitle } from '../CardTitle/CardTitle';
import { FieldsProgress } from '../CreateUpdateContainer/FieldsProgress';

/**
 * Section of a form: collapsible card with an icon tile, a title on the left
 * and the filling progress on the right. Its children are laid out on a grid.
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.id - Id of the section (target of the sections menu).
 * @param {string} props.className - Extra class names of the section wrapper.
 * @param {string} props.icon - Icon name of the title (see CardTitle).
 * @param {string} props.title - Title of the section.
 * @param {Object[]} props.fields - Fields of the section, used for the progress.
 * @param {React.ReactNode} props.children - Content of the section.
 * @returns {JSX.Element} - The FormSection component.
 */
export const FormSection = ({
  id,
  className,
  icon,
  title,
  fields,
  children
}) => (
  <div id={id} className={`form-section ${className}`.trim()}>
    <Collapse
      className="form-card-grid"
      defaultActiveKey={['section']}
      expandIconPosition="end"
      bordered={false}
      items={[
        {
          key: 'section',
          label: <CardTitle icon={icon}>{title}</CardTitle>,
          extra: fields ? <FieldsProgress fields={fields} /> : null,
          children
        }
      ]}
    />
  </div>
);

FormSection.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(PropTypes.shape({})),
  children: PropTypes.node
};

FormSection.defaultProps = {
  id: undefined,
  className: '',
  icon: 'profile',
  fields: null,
  children: null
};
